export const LONG_AMOUNT_COEFFICENT_CHANGE = 70_000;
export const LONG_TERM_FIRST_RANGE_COEFFICIENT = 2.92;
export const LONG_TERM_SECOND_RANGE_COEFFICIENT = 1.7;
